import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    "@type": "ListItem" as const,
    position: index + 1,
    item: item.path
      ? { "@id": `https://jmtt.example.com${item.path}`, name: item.label }
      : { name: item.label },
  }));

  return (
    <>
      <nav aria-label="面包屑导航" className="text-sm">
        <ol className="flex items-center flex-wrap gap-1 text-foreground-500">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 mx-1"></i>
              )}
              {item.path ? (
                <Link
                  to={item.path}
                  className="hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: schemaItems,
          }),
        }}
      />
    </>
  );
}